import { c as _c } from "react/compiler-runtime";
import { Box, HStack, IconButton, Text, VStack } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { ChatDirectThreadList } from '@src/components/sco/Chat/ChatDirectThreadList';
import { LuX } from 'react-icons/lu';
export const UserMatchChatList = props => {
  const $ = _c(9);
  const layout = useParentAppLayout();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Text textStyle="labelMd" width="full">Recent Messages</Text>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== layout) {
    t1 = () => {
      layout.toggle("matching-aside");
    };
    $[1] = layout;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LuX />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <HStack align="center" backdropFilter="blur(10px)" borderBottom="1px solid" borderBottomColor="blackAlpha.500" height="3.5em" justify="flex-start" padding="1em" zIndex={1}>{t0}<IconButton aria-label="Close Messages" borderRadius="md" size="sm" variant="outline" onClick={t1}>{t2}</IconButton></HStack>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Box flexGrow={1} maxHeight="full" overflowY="auto"><ChatDirectThreadList /></Box>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <VStack align="stretch" gap={0} height="full" justify="stretch" width="full">{t3}{t4}</VStack>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};